import {CompositeFilterDescriptor, filterBy, FilterDescriptor} from "@progress/kendo-data-query"
import {ComboBoxChangeEvent, ComboBoxFilterChangeEvent, ListItemProps} from "@progress/kendo-react-dropdowns"
import {Field, FieldRenderProps} from "@progress/kendo-react-form"
import {Checkbox} from "@progress/kendo-react-inputs"
import {MDBCol, MDBRow} from "mdbreact"
import React from "react"
import {setPrepareByDealerId} from "../../../containers/MotBooking/bookingSlice"
import {RootState} from "../../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../../store"
import BookingMultiColumnComboBox from "../../Shared/multiColumnComboBox"
import dayjs from "dayjs"
export const PrepareByDealerCheckBox = (fieldRenderProps: FieldRenderProps): JSX.Element => {
    const dispatch = useAppDispatch()
    const {disabled, name, value, label} = fieldRenderProps

    return (
        <Checkbox
            className="small"
            name={name}
            label={label}
            style={{opacity: 1, marginRight: "5px"}}
            onClick={() => dispatch(setPrepareByDealerId(!value))}
            checked={value}
            disabled={disabled}
        />
    )
}

const BKPreparerIDComboBox = ({
    onChange,
    checkBookingID,
    preparerDealerName,
    preparerID,
    bookingDate,
    isPreparerEditable,
}: {
    onChange: (ev: ComboBoxChangeEvent) => void
    checkBookingID: boolean
    preparerDealerName: string | null
    preparerID: string
    bookingDate: string
    isPreparerEditable: boolean | null
}) => {
    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)
    const dispatch = useAppDispatch()

    const [filter, setFilter] = React.useState<CompositeFilterDescriptor>()
    const [preparedByDealer, setPreparedByDealer] = React.useState<boolean>(
        preparerID !== "NA" && preparerID !== "" && preparerID !== undefined,
    )
    const preparerCopy = [
        {
            preparerDealerName,
            preparerID,
        },
    ]
    const preparerIDs = [
        {preparerID: "NA", preparerDealerName: "NA", dealerId: null}, // Add 'NA' as a valid option
        ...userDealers
            .filter(x => x.preparerId)
            .map((x, i) => ({
                ID: `${x.dealerName}~${i}`,
                preparerID: x.preparerId,
                dealerId: x.dealerId,
                preparerDealerName: x.dealerName,
            })),
    ]
    const columns = [
        {
            field: "preparerID",
            header: "Preparer ID",
            width: "120px",
        },
        {
            field: "preparerDealerName",
            header: "Dealer",
            width: "150px",
        },
    ]

    const columnItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const children = columns.map((col, i) => (
            <span className="k-table-td" style={{width: col.width}} key={i}>
                {itemProps.dataItem[col.field]}
            </span>
        ))
        return React.cloneElement(li, {...li.props}, children)
    }

    const onFilterChange = (event: ComboBoxFilterChangeEvent) => {
        if (event) {
            const filters = [
                {field: "preparerID", operator: "contains", value: event.filter.value},
                {field: "preparerDealerName", operator: "contains", value: event.filter.value},
            ] as Array<FilterDescriptor>
            setFilter({logic: "or", filters})
        }
    }

    const handlePreparerIDChange = (event: ComboBoxChangeEvent) => {
        const newPreparerID = event.value ? event.value.preparerID : null // Set to null if no value is selected
        setPreparedByDealer(newPreparerID !== "NA" && newPreparerID !== null)
        dispatch(setPrepareByDealerId(preparedByDealer))
        onChange(event)
    }

    return (
        <MDBRow>
            <MDBCol md="6">
                <Field
                    required
                    name={"preparerDealerName"}
                    component={BookingMultiColumnComboBox}
                    textField="preparerID"
                    dataItemKey={"preparerDealerName"}
                    value={preparerDealerName}
                    data={isPreparerEditable ? preparerCopy : filter ? filterBy(preparerIDs, filter) : preparerIDs}
                    filterable={true}
                    onFilterChange={onFilterChange}
                    label={"PreparerID"}
                    loading={false}
                    columns={columns}
                    itemRender={columnItemRender}
                    onChange={onChange}
                    disabled={
                        checkBookingID &&
                        dayjs(new Date()).startOf("day").toDate() >=
                            dayjs(new Date(bookingDate)).startOf("day").toDate()
                    }
                />
            </MDBCol>
            <MDBCol md="6" className="mt-2 pt-3">
                <Field
                    label={"Affects Pass Rate"}
                    name={"preparedByDealer"}
                    component={PrepareByDealerCheckBox}
                    value={preparedByDealer}
                    disabled={true}
                    // disabled={
                    //     checkBookingID &&
                    //     dayjs(new Date()).startOf("day").toDate() >=
                    //         dayjs(new Date(bookingDate)).startOf("day").toDate()
                    // }
                ></Field>
            </MDBCol>
        </MDBRow>
    )
}

export default BKPreparerIDComboBox
